import * as React from 'react';
import '../../../Typography/index.js';
import '../../../VisualAssets/IconV3/index.js';
import { useValidationMessage } from './hooks/useValidationMessage.js';
import { IconV3 as IconV3Memoized } from '../../../VisualAssets/IconV3/Icon.js';
import { Typography } from '../../../Typography/Typography.js';

var ValidationMessageComponent = function ValidationMessageComponent(props) {
  var _useValidationMessage = useValidationMessage(props),
    containerProps = _useValidationMessage.containerProps,
    iconProps = _useValidationMessage.iconProps,
    textProps = _useValidationMessage.textProps;
  return /*#__PURE__*/React.createElement("div", containerProps, /*#__PURE__*/React.createElement(IconV3Memoized, iconProps), /*#__PURE__*/React.createElement(Typography, textProps, props.message));
};
ValidationMessageComponent.displayName = 'ValidationMessage';
var ValidationMessage = /*#__PURE__*/React.memo(ValidationMessageComponent);

export { ValidationMessage, ValidationMessageComponent };
//# sourceMappingURL=ValidationMessage.js.map
